import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20modern%20entertainment%20background%20with%20warm%20orange%20and%20coral%20gradient%20waves%2C%20soft%20flowing%20curves%2C%20cinematic%20atmosphere%2C%20dark%20elegant%20accents%2C%20luxury%20theater%20vibe%2C%20no%20text%2C%20no%20people%2C%20minimalist%20abstract%20art&width=1800&height=900&seq=hero-bg-main-2026&orientation=landscape"
          alt="黄瓜视频在线 - 免费高清视频播放平台"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center w-full max-w-[800px]">
          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white mb-4 leading-tight">
            免费高清视频<span className="text-primary-400">在线播放</span>平台
          </h1>
          <p className="text-base md:text-lg text-white/80 mb-8 max-w-[600px] mx-auto">
            海量正版视频内容，无需下载，随时随地畅享优质观影体验
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/dianshiju"
              className="px-8 py-3 rounded-full text-base font-medium bg-primary-500 text-white hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-play-circle-line mr-1.5"></i>开始观看
            </Link>
            <Link
              to="/category/dianying"
              className="px-8 py-3 rounded-full text-base font-medium bg-white/15 text-white hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer backdrop-blur-sm"
            >
              <i className="ri-movie-2-line mr-1.5"></i>热门电影
            </Link>
          </div>
          <div className="flex items-center justify-center gap-6 mt-8">
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">5亿+</div>
              <div className="text-xs md:text-sm text-white/60">注册用户</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">10万+</div>
              <div className="text-xs md:text-sm text-white/60">视频内容</div>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-white">4K</div>
              <div className="text-xs md:text-sm text-white/60">超清画质</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}